(function ($) {
        if ($('.page-template-search').length) {
            //
            // Polyfill for object.assign, needed for lozad plugin to work on IE11
            //
            // window.ObjectAssign.polyfill();

            var url = new URL(window.location);
            var urlParams = (new URL(document.location)).searchParams;

            //Delay function for User input
            function delay(callback, ms) {
                var timer = 0;
                return function () {
                    var context = this, args = arguments;
                    clearTimeout(timer);
                    timer = setTimeout(function () {
                        callback.apply(context, args);
                    }, ms || 0);
                };
            }

            //Product search with input
            $('.search-input').on('change, keyup', delay(function (e) {
                if ($(this).val() !== '') {
                    $('.search-wrap').addClass('has-value');
                    updateUrlParams('search', $(this).val());
                    getSearch();
                } else {
                    $('.search-wrap').removeClass('has-value');
                    updateUrlParams('search');
                    $('.search-results').empty();
                    $('.clear-section').empty();
                }
            }, 400));

            //Remove search results
            $('.remove-query').on('click', function () {
                $('.search-input').val('');
                $('.search-wrap').removeClass('has-value');
                updateUrlParams('search');
                $('.search-results').empty();
                $('.clear-section').empty();
            });

            $(document).on("click", ".show-more", function () {
                var categoryContainer = $(this).closest('.search-category-container');
                var lastIndex = categoryContainer.find('.result.visible').last().data('index');
                for (var i = lastIndex + 1; i <= (lastIndex + 10); i++) {
                    categoryContainer.find('.result[data-index="' + i + '"]').addClass('visible');
                    if (i === categoryContainer.find('.result').length) {
                        categoryContainer.find('.show-more').addClass('hidden');
                        categoryContainer.find('.show-less').removeClass('hidden');
                    }
                }
            });

            $(document).on("click", ".show-less", function () {
                var categoryContainer = $(this).closest('.search-category-container');
                categoryContainer.find('.result').removeClass('visible');
                for (var i = 1; i <= 10; i++) {
                    categoryContainer.find('.result[data-index="' + i + '"]').addClass('visible');
                    categoryContainer.find('.show-more').removeClass('hidden');
                    categoryContainer.find('.show-less').addClass('hidden');
                }
            });

            //Category select
            $(document).on("click", ".category-selection", function () {
                var category = $(this).attr('data-category');
                if (!$(this).hasClass('disabled')) {
                    $(this).addClass('disabled');
                    $('.search-category-container[data-category="' + category + '"]').css('display', 'none');
                } else {
                    $(this).removeClass('disabled');
                    $('.search-category-container[data-category="' + category + '"]').css('display', 'block');
                }
            });


            //Get all search queries
            function getSearch() {
                var urlParams = new URLSearchParams(location.search);
                var data = {
                    'action': 'load_search',
                    'search': urlParams.get('search'),
                };

                $('.search-results').addClass('loading');
                $('.clear-section').addClass('loading');
                $('.search-wrap').addClass('loading');

                setTimeout(function () {
                    $.get(postmpwp.ajax_url, data, function (response) {
                        if (response.success) {
                            $('.search-results').empty();
                            $('.clear-section').empty();
                            $('.clear-section').append(response.data.total);
                            $('.clear-section').append(response.data.filter);
                            $.each(response.data.search, function (index, value) {
                                $('.search-results').append(value);
                            });
                            var searchword = urlParams.get('search');
                            var custfilter = new RegExp(searchword, "ig");
                            var repstr = "<span class='match'>" + searchword + "</span>";

                            if (searchword != "") {
                                $('.result').each(function () {
                                    var title = $(this).find('.title');
                                    var text = $(this).find('p');

                                    var titleContent = title.text().replace(custfilter, repstr);
                                    var textContent = text.text().replace(custfilter, repstr);

                                    title.html(titleContent);
                                    text.html(textContent);
                                })
                            }

                            $.each(response.data.postsFound, function (index, value) {
                                $('.search-category[data-category="' + index + '"] .postsFound').text(value);
                            });
                            $('.search-results').removeClass('loading');
                            $('.clear-section').removeClass('loading');
                            $('.search-wrap').removeClass('loading');
                        } else {
                            $('.search-results').removeClass('loading');
                            $('.clear-section').removeClass('loading');
                            $('.search-wrap').removeClass('loading');
                        }
                    });
                }, 600);
            }

            function updateUrlParams(param, value) {
                if (value) {
                    urlParams.set(param, value);

                } else {
                    urlParams.delete(param);
                }

                url.search = urlParams.toString();

                history.replaceState({}, null, url.toString());
            }

            $(window).on('load', function () {
                if (urlParams.get('search')) {
                    getSearch();
                }
            })
        }
    }
)(jQuery);